import styled from 'styled-components';
import { ButtonIconMixin } from '../../mixins/components/ButtonIconMixin';

/**
 * @since 8.12.0
 */
var TextButtonIcon = /*#__PURE__*/styled.span.withConfig({
  displayName: "TextButtonIcon",
  componentId: "c11n-8-107-0__sc-1penltx-0"
})(["", ""], ButtonIconMixin);
TextButtonIcon.displayName = 'TextButtonIcon';

/** @component */
export { TextButtonIcon };